import { ActionHandler, ActionSource } from '../types';

export function addActionSource(
  source: Partial<ActionSource>,
  actionHandler: ActionHandler
): ActionHandler {
  return action => {
    const actionWithPartialSource = 'source' in action ? action : { ...action, source: {} };

    actionHandler({
      ...actionWithPartialSource,
      source: {
        ...actionWithPartialSource.source,
        ...source,
      },
    });
  };
}
